import React from "react";
import remarkBreaks from "remark-breaks";
function breaks() {
  return {
    remark: (processor) => processor.use(remarkBreaks),
    mdxRemark: (processor) => processor.use(remarkBreaks),
    mdxHandlerList: () => (input, prev) => {
      if ("res" in input)
        return input;
      const node = input.source;
      if (node.type === "break") {
        if ((prev == null ? void 0 : prev.type) === "mdxJsxTextElement") {
          return {
            res: null
          };
        }
      }
      if (node.type !== "text")
        return input;
      if (!node.value) {
        return {
          res: null
        };
      }
      node.value = node.value;
      if (!node.value.includes("\n")) {
        return {
          res: node.value
        };
      }
      if (node.value === "\n") {
        if ((prev == null ? void 0 : prev.type) === "mdxJsxTextElement") {
          return {
            res: null
          };
        }
        return {
          res: /* @__PURE__ */ React.createElement("br", null)
        };
      }
      if (node.value.includes("\n") && node.value.trim() === "") {
        if ((prev == null ? void 0 : prev.type) === "mdxJsxTextElement") {
          return {
            res: null
          };
        }
      }
      return {
        res: /* @__PURE__ */ React.createElement(React.Fragment, null, node.value.split("\n").map((item, index) => {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, index !== 0 ? /* @__PURE__ */ React.createElement("br", null) : null, item);
        }))
      };
    }
  };
}
export {
  breaks
};
